import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';
import Notification from './Notification';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        innerPanel: {
            padding: '10px 8px 8px 8px'
        },
        panel: {
            borderRadius: 4,
            backgroundColor: theme.palette.grey[200],
        },
        noPanel: {
            backgroundColor: "inherit",
        },
        panelContent: {
            clear: 'both',
            paddingTop: 1,
            overflow: 'hidden'
        }
    }, globalStyles);
};

const TitledPanelInner =

    function (props) {

        const { classes, margin, title, actions, fontSize, height, dataTest, information, highlight, warning, overflow, required } = props;

        return (
            <div
                data-test={dataTest}
                data-highlight={highlight}
                className={title === "" ? classes.noPanel : classes.panel}
                style={
                    {
                        maxWidth: '100%',
                        ...(margin) ? { marginTop: '20px' } : {},
                        ...(height === "full") ? { height: '100%' } : {},
                        ...(highlight) ? { backgroundColor: '#d0d0d0' } : {}
                    }
                }>
                <div className={classes.innerPanel} 
                style={
                    {
                        ...(title === undefined) ? { paddingTop: props.children ? 0: 6, paddingLeft: 0, paddingBottom: 0 } : {}
                    }
                }>
                    <div style={{ float: 'right', marginTop: -7 }}>
                        {actions !== false ? actions : null}
                    </div>
                    {title &&
                        <Typography
                            data-test={dataTest ? dataTest + "-title" : null}
                            className={fontSize === "medium" ? classes.subHeading : classes.subHeadingLarge}
                            style={{ marginBottom: '6px', overflowWrap: 'break-word' }}>
                            {title}
                            {required && <Tooltip title="This field is mandatory"><span> *</span></Tooltip>}
                            {information && <Tooltip title={information}>
                                <span data-test="information" style={{ marginLeft: 6 }}>
                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'top', color: '#808080' }} />
                                </span>
                            </Tooltip>}
                        </Typography>
                    }
                    {warning && warning !== "" &&
                        <div style={{ marginBottom: 12 }}>
                            <Notification error={false} text={warning} dataTest="warning" />
                        </div>
                    }
                    <div data-test="panel-content" className={classes.panelContent} style={overflow ? { overflow: 'visible' } : {}}>
                        {props.children}
                    </div>
                </div>
            </div>
        );
    };

const TitledPanel = withStyles(styles)(TitledPanelInner);

TitledPanel.defaultProps = {
    highlight: false,
    margin: false,
    fontSize: "medium",
    overflow: false,
    height: "normal",
    required: false
};

TitledPanel.propTypes = {
    highlight: PropTypes.bool,
    dataTest: PropTypes.string,
    title: PropTypes.string,
    margin: PropTypes.bool,
    actions: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object),
        PropTypes.object,
    ]),
    required: PropTypes.bool,
    classes: PropTypes.object,
    information: PropTypes.object,
    overflow: PropTypes.bool,
    height: PropTypes.oneOf(["normal", "extended", "full"]),
    fontSize: PropTypes.oneOf(["medium", "large"])
};

TitledPanelInner.propTypes = {
    highlight: PropTypes.bool,
    overflow: PropTypes.bool,
    actions: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object),
        PropTypes.object,
    ]),
    classes: PropTypes.object,
    dataTest: PropTypes.string,
    information: PropTypes.object,
    warning: PropTypes.string,
    required: PropTypes.bool,
    title: PropTypes.string,
    margin: PropTypes.bool,
    children: PropTypes.any,
    height: PropTypes.oneOf(["normal", "extended", "full"]),
    fontSize: PropTypes.oneOf(["medium", "large"])
};

export default TitledPanel;